import React from 'react';
import { Wallet } from 'lucide-react';
import { useWallet } from '../../context/WalletContext';
import { formatMoney } from '../../utils/formatMoney';

export function UsdtBalanceDisplay() {
  const { balance } = useWallet();

  return (
    <div className="rounded-2xl border-2 border-brand-gold bg-gradient-to-br from-brand-gold-light/40 via-white to-red-50 p-8 text-center shadow-lg">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand-red">
        <Wallet className="h-8 w-8 text-white" />
      </div>
      <p className="text-sm font-medium uppercase tracking-widest text-gray-600">
        ยอดในกระเป๋าเว็บไซต์
      </p>
      <p className="mt-2 text-5xl font-bold text-brand-gold">
        {formatMoney(balance)}
      </p>
      <p className="mt-3 text-sm text-gray-500">
        ฝากจากกระเป๋า Digital · ใช้เล่นลอตเตอรี่และยี่กี
      </p>
    </div>
  );
}
